import { VersionInfo } from '../../types/firmware'
import { FeatureBase } from '../FeatureBase'
import { compareVersions } from '../../utils/verify'

export * from './hostHooks'

// 扩展功能注册表
declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    firmware: IFirmwareFeature
  }
}

export interface IFirmwareFeature {
  /** 读取固件版本 */
  getFirmwareVersion(): Promise<VersionInfo[]>
  /** 检查版本更新：保留当前 version，并按设备/芯片返回 onlineVersion 与 canUpdate。 */
  checkFirmwareUpdate(): Promise<VersionInfo[]>
  /**
   * 固件升级（含下载 / 进 Boot / WebHID 授权编排）。
   * 主通道已是 `update`（Boot 恢复）时自动跳过进 Boot，直接 IAP。
   * WebHID 授权 UI 由 setFirmwareHostHooks 注入，页面只需调用本方法。
   */
  updateFirmware(report?: () => void): Promise<void>
  /**
   * 获取固件附件下载地址
   */
  getFirmwareAttachmentUrl(type: string): Promise<string>
}

export class FirmwareFeature extends FeatureBase implements IFirmwareFeature {
  /**
   * 统一判断线上固件是否具备版本资格。
   * 关键：测试策略仅跳过版本高低比较，不代替具体实现中的硬件与协议检查。
   */
  protected canUpdateByVersion(onlineVersion: unknown, localVersion: unknown): boolean {
    if (typeof onlineVersion !== 'string' || typeof localVersion !== 'string') {
      return false
    }
    const normalizedOnlineVersion = onlineVersion.trim()
    const normalizedLocalVersion = localVersion.trim()
    if (!normalizedOnlineVersion || !normalizedLocalVersion) return false

    // 关键：历史自定义设备/测试替身可能尚未实现新 getter，缺失时安全回落严格策略。
    const getPolicy = this.device.getFirmwareVersionPolicy
    if (typeof getPolicy === 'function' && getPolicy.call(this.device) === 'any-version') {
      return true
    }
    return compareVersions(normalizedOnlineVersion, normalizedLocalVersion) > 0
  }

  getFirmwareVersion(): Promise<VersionInfo[]> {
    return this.unsupported('FirmwareFeature.getFirmwareVersion')
  }
  checkFirmwareUpdate(): Promise<VersionInfo[]> {
    return this.unsupported('FirmwareFeature.checkFirmwareUpdate')
  }
  updateFirmware(_report?: () => void): Promise<void> {
    return this.unsupported('FirmwareFeature.updateFirmware')
  }
  getFirmwareAttachmentUrl(_type: string): Promise<string> {
    return this.unsupported('FirmwareFeature.getFirmwareAttachmentUrl')
  }
}
